export const reliability = [
  {
    title: "امنیت پیشرفته",
    desc: "محافظت‌ چند لایه در برابر نفوذ، تهدیدات و انواع حملات سایبری",
    logo: "startup.svg",
    imgAlt: "امنیت پیشرفته",
    imgTitle: "امنیت پیشرفته",
  },
  {
    title: "مستقل از اینترنت",
    desc: "انتقال ترافیک برون سازمانی در مسیر ایزوله از اینترنت عمومی",
    logo: "disaster.svg",
    imgAlt: "مستقل از اینترنت",
    imgTitle: "مستقل از اینترنت",
  },
  {
    title: "مطابق با الزامات امنیتی",
    desc: "مورد تایید نهاد‌های بالادستی از جمله سازمان پدافند غیرعامل",
    logo: "test.svg",
    imgAlt: "مطابق با الزامات امنیتی",
    imgTitle: "مطابق با الزامات امنیتی",
  },
  {
    title: "پشتیبانی تخصصی",
    desc: "با پشتیبانی فنی از خدمات زیرساخت اختصاصی آبالون به ‌صورت ۲۴/۷",
    logo: "virtualOrganization.svg",
    imgAlt: "پشتیبانی تخصصی",
    imgTitle: "پشتیبانی تخصصی",
  },
];

export const solutions = [
  {
    img: "1.svg",
    title: "ابر خصوصی آبالون",
    desc: "با ابر خصوصی به‌عنوان یکی از خدمات زیرساخت اختصاصی آبالون، به محیط ابری اختصاصی در سازمان خود مهاجرت کنید. تیم متخصص آبالون با تحلیل زیرساخت فعلی، معماری سرویس‌های مورد نیاز را طراحی کرده و یک محیط پایدار در اختیار شما قرار می‌دهد که امنیت داده‌ها و کنترل کامل زیرساخت را فراهم می‌کند.",
    link: "/privatecloud",
    linkTitle: "آشنایی با ابر خصوصی آبالون",
    linkText: "ابر خصوصی آبالون",
  },
  {
    img: "2.svg",
    title: "ابر ایزوله آبالون",
    desc: "با ابر ایزوله به‌عنوان یکی از خدمات زیرساخت اختصاصی آبالون، زیرساخت خود از هر نقطه کشور را به سرویس‌های ابری آبالون متصل کنید. این سرویس بر بستر شبکه کشوری نورونتا، دسترسی مستقیم و ایمن به دیتاسنترهای آبالون را بدون وابستگی به اینترنت عمومی ممکن می‌کند.",
    link: "/isolated-cloud",
    linkTitle: "آشنایی با ابر ایزوله آبالون",
    linkText: "ابر ایزوله آبالون",
  },
  {
    img: "3.svg",
    title: "کوبرنتیز آبالون",
    desc: "با کوبرنتیز مدیریت‌شده به‌عنوان یکی از خدمات زیرساخت اختصاصی آبالون، کنترل کامل اپلیکیشن‌های کانتینری را به‌سادگی به دست بگیرید. این سرویس با خودکارسازی فرایندها و بهینه‌سازی منابع، بستری پایدار و منعطف و در عین حال امن را برای اجرای اپلیکیشن‌ها فراهم می‌کند.",
    link: "/kubernetes",
    linkTitle: "آشنایی با کوبرنتیز آبالون",
    linkText: "کوبرنتیز آبالون",
  },
];

export const popularServices = [
  {
    title: "شبکه توزیع محتوای CDN آبالون",
    desc: "با بیش از ۴۰ پاپ‌سایت فعال در ایران و ۵ قاره جهان، محتوای وب‌سایت و سرویس‌های آنلاین سازمان خود را با کمترین تأخیر، سریع‌تر و ایمن‌تر به کاربران برسانید.",
    logo: "ManagedService-Service.svg",
    route: "/cdn",
  },
  {
    title: "راهکارهای تخصصی آبالون",
    desc: "با راهـکارهـای تـخـصـصـی آبالون، بدون پیچیدگـی فـنـی، مسـیر مهـاجرت، مدیریت و امنیت ابری را ساده‌تر کنید و سازمان‌تان را در مسیر رشد و تحول دیجیتال پیش ببرید.",
    logo: "VPS-Service.svg",
    route: "/solutions",
  },
  {
    title: "مهاجرت ابری",
    desc: "با راهکار مهاجرت ابری، زیرساخت‌های سنتی یا مونولیتیک خود را به‌صورت گام‌به‌گام و با حداقل اختلال در عملیات جاری به محیط ابری منتقل کنید.",
    logo: "VPC-Service.svg",
    route: "/cloud-migration",
  },
  {
    title: "امنیت ابری",
    desc: "با استفاده از راهکارهای امنیتی پیشرفته مانند فضای کاری امن، فایروال ابری، WAF و سامانه SIEM از سرویس‌های سازمانی خود در فضای ابری محافظت کنید. ",
    logo: "CloudGuard-Service.svg",
    route: "/cloud-security",
  },
];

export const questions = [
  {
    title: "خدمات زیرساخت اختصاصی آبالون شامل چه سرویس‌هایی می‌شوند؟",
    answer:
      "این مجموعه شامل سه سرویس کلیدی است: ابر خصوصی برای مهاجرت امن و اختصاصی به محیط ابری، ابر ایزوله برای اتصال پایدار بر بستر شبکه نورونتا، و کوبرنتیز مدیریت‌شده برای اجرای اپلیکیشن‌های کانتینری با پایداری بالا.",
  },
  {
    title: "تفاوت ابر خصوصی و ابر ایزوله آبالون چیست؟",
    answer:
      "ابر خصوصی محیطی کاملاً اختصاصی در درون سازمان فراهم می‌کند و امنیت و کنترل کامل داده‌ها را تضمین می‌نماید؛ در مقابل، ابر ایزوله بر بستر شبکه نورونتا ارائه می‌شود و تمرکز آن بر ارتباط امن با دیتاسنترهای آبالون بدون وابستگی به اینترنت عمومی است.",
  },
  {
    title:
      "مزیت اصلی خدمات زیرساخت اختصاصی آبالون نسبت به سرویس‌های عمومی ابری چیست؟",
    answer:
      "خدمات زیرساخت اختصاصی آبالون با تمرکز بر امنیت، کنترل کامل و انطباق با الزامات امنیتی طراحی شده‌اند. این خدمات امکان استقرار اختصاصی، ارتباط ایزوله از اینترنت و مدیریت تخصصی زیرساخت را فراهم می‌کنند.",
  },
  {
    title:
      "چه سازمان‌هایی بیشترین بهره را از خدمات زیرساخت اختصاصی آبالون می‌برند؟",
    answer:
      "سازمان‌ها و نهاد‌های دولتی با داده‌های حساس یا محرمانه، سازمان‌هایی با پراکندگی جغرافیایی بالا، و کسب‌وکارهایی که نیازمند پایداری و دسترس‌پذیری مداوم هستند، بیشترین ارزش را از این خدمات دریافت می‌کنند.",
  },
];
